export const FETCH_COUNTRIES_LOADING = '@@services/countries/LOADING';
export const FETCH_COUNTRIES_SUCCESS = '@@services/countries/SUCCESS';
export const FETCH_COUNTRIES_FAILURE = '@@services/countries/FAILURE';
